// Global registry of open add/edit forms, so the Android hardware back button can
// implement: filled form → CLEAR it; empty form → CLOSE it; no form → let the
// caller navigate back (and the root page asks "exit?"). Module-level (not React
// context) so BackButtonHandler can call it without prop-drilling.
//
// Each open form pushes a handler: { isDirty(): bool, clear(): void, close(): void }
// LIFO — the most recently opened form is handled first (matches nested modals).
const stack = [];

// Register an open form. Returns an unregister fn (call on close/unmount).
export function pushForm(handler) {
  stack.push(handler);
  return () => {
    const i = stack.lastIndexOf(handler);
    if (i >= 0) stack.splice(i, 1);
  };
}

export function hasOpenForm() {
  return stack.length > 0;
}

// Escape key (desktop): just CLOSE the top-most form, never clear typed content.
// Returns true if a form was closed.
export function closeTopForm() {
  const h = stack[stack.length - 1];
  if (!h) return false;
  if (h.close) h.close();
  return true;
}

// Handle a back press against the top-most form.
// Returns true if it consumed the press (caller should NOT navigate/exit):
//   - form is dirty  → clear it, stay open, consume
//   - form is empty  → close it, consume
// Returns false if there's no open form (caller handles navigation/exit).
export function handleFormBack() {
  const h = stack[stack.length - 1];
  if (!h) return false;
  try {
    if (h.isDirty && h.isDirty()) {
      if (h.clear) h.clear();
      return true;
    }
    if (h.close) h.close();
  } catch {
    if (h.close) h.close();
  }
  return true;
}
